import React, { useState } from "react";
import QuizEngine from "./QuizEngine";
import { QuizHeader } from "../steps/shared";

const ContactLensRouter = ({ flow, categoryId, onFilterChange, prevToCategoryPicker }) => {
  const [branch, setBranch] = useState(null); // "yes" | "no" | null

  if (!branch) {
    return (
      <section className="qz-step">
        <QuizHeader title={flow.entryQuestion.question} onBack={prevToCategoryPicker} />

        <div className="qz-grid qz-grid--fit qz-grid--options" style={{ "--qz-cols": 2 }}>
          {flow.entryQuestion.options.map((opt) => (
            <button key={opt.id} type="button" className="qz-option" onClick={() => setBranch(opt.id)}>
              <span className="qz-option__mark" aria-hidden="true" />
              <span className="qz-option__text">
                <span className="qz-option__name">{opt.name}</span>
                <span className="qz-option__sub">{opt.sub}</span>
              </span>
            </button>
          ))}
        </div>
      </section>
    );
  }

  const subFlow = branch === "yes" ? flow.yesBranch : flow.noBranch;

  return (
    <QuizEngine
      flow={{ steps: subFlow.steps, onComplete: flow.onComplete }}
      categoryId={categoryId}
      masterData={{}}
      onFilterChange={onFilterChange}
      prevToCategoryPicker={() => setBranch(null)}
    />
  );
};

export default ContactLensRouter;